import type { Program } from '@gyym/sdk'

import { sanitizeString } from '../sanitize'
import type { OfferCatalog } from '../types'

/**
 * Build description text with duration and points
 */
const buildServiceDescription = (program: Program): string => {
  const point = program.minimumPoint ?? program.minTimetablePoint
  const parts: string[] = []

  if (program.duration) {
    parts.push(`${program.duration}分間`)
  }

  if (program.description) {
    parts.push(sanitizeString(program.description))
  }

  if (point) {
    parts.push(`${point.toLocaleString()}pt`)
  }

  return parts.join(' / ')
}

/**
 * Build hasOfferCatalog from facility programs
 * Represents available programs for reservation
 *
 * Note: hoursAvailable is omitted because timetables are lazily fetched
 * client-side and not available at SSR due to "large page data" issues.
 */
export const buildOfferCatalog = (programs: Program[]): OfferCatalog | null => {
  if (!programs || programs.length === 0) {
    return null
  }

  return {
    '@type': 'OfferCatalog',
    name: '施設予約スケジュール',
    itemListElement: programs.map((program) => ({
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: sanitizeString(program.name),
        description: buildServiceDescription(program),
      },
      availability: 'https://schema.org/InStock',
    })),
  }
}
